import { useEffect, useMemo, type Dispatch, type SetStateAction } from 'react';
import type { DailyQuestView } from '../../../models/quest';
import { getQuestCategory } from '../questCategories';
import type { QuestCategory } from '../types';

export interface UseDailyQuestCategoriesParams {
  quests: DailyQuestView[];
  activeCategory: QuestCategory;
  setActiveCategory: Dispatch<SetStateAction<QuestCategory>>;
}

export interface UseDailyQuestCategoriesResult {
  categoriesWithQuests: Set<QuestCategory>;
}

export function useDailyQuestCategories({
  quests,
  activeCategory,
  setActiveCategory,
}: UseDailyQuestCategoriesParams): UseDailyQuestCategoriesResult {
  // Обчислюємо, які категорії мають квести (для приховування порожніх пілюль)
  const categoriesWithQuests = useMemo(() => {
    const s = new Set<QuestCategory>();
    quests.forEach(q => {
      const cat = getQuestCategory(q);
      if (cat) s.add(cat);
    });
    return s;
  }, [quests]);

  // Якщо активна категорія стала порожньою — переходимо на "daily"
  useEffect(() => {
    if (quests.length > 0 && !categoriesWithQuests.has(activeCategory)) {
      setActiveCategory("daily");
    }
  }, [activeCategory, categoriesWithQuests, quests.length, setActiveCategory]);

  return {
    categoriesWithQuests,
  };
}
